import { useTranslation } from 'react-i18next';

export default function StatsBar() {
  const { t } = useTranslation();

  const stats = [
    { value: '70%', label: t('stats.savings') },
    { value: '14+', label: t('stats.categories_count') },
    { value: '5000+', label: t('stats.products') },
    { value: '24h', label: t('stats.updates') },
  ];

  return (
    <section className="bg-background-50 py-8 md:py-10">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap items-center justify-center gap-10 md:gap-14">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">{stat.value}</p>
                <p className="text-foreground-500 text-xs md:text-sm mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}